import { render, staticRenderFns } from "./CoffeeFilter.vue?vue&type=template&id=3548b769&"
import script from "./CoffeeFilter.vue?vue&type=script&lang=js&"
export * from "./CoffeeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports